import React from 'react';
import Modal from './modal/Modal';

type GoMoneytreeSiteDialogProps = {
  onOK: () => void;
  onCancel: () => void;
};

const GoMoneytreeSiteDialog: React.FC<GoMoneytreeSiteDialogProps> = ({
  onOK,
  onCancel,
  ...props
}) => {
  return (
    <div onClick={onCancel}>
      <Modal onClose={onCancel} modalStyle="w-10/12">
        <div
          onClick={event => {
            event.stopPropagation();
          }}
          className="flex flex-col items-center">
          <div className="p-4 font-bold">Moneytreeへ移動します</div>
          <div className="flex flex-col items-center">
            <p>Moneytreeサイトへアクセスします。</p>
            <p>よろしいですか？</p>
          </div>
          <div
            className="ui-btn mt-4 mx-3 p-2 w-10/12 cursor-pointer"
            onClick={onOK}>
            OK
          </div>
          <div className="my-4 cursor-pointer" onClick={onCancel}>
            キャンセル
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GoMoneytreeSiteDialog;
